import React from 'react';
import PropTypes from 'prop-types';
import UiKitTabs from 'components/UiKit/Tabs';
import productIcon from 'assets/product-icon.svg';
import ActiveIngredientSummary from './ActiveIngredientSummary';
import PropertyAppliedProducts from '../PropertyAppliedProducts';
import FertilizerSummation from '../FertilizerSummation';
import PropertyCardHeader from '../PropertyCardHeader';

const PropertyCropZoneProducts = ({ id }) => {
  return (
    <div>
      <PropertyCardHeader
        title="Products"
        description="All active and used products during the selected crop season"
        icon={productIcon}
      />
      <UiKitTabs>
        <UiKitTabs.Tab label="All Applied Products">
          <PropertyAppliedProducts level="cropzone" id={id} />
        </UiKitTabs.Tab>
        <UiKitTabs.Tab label="Fertilizer Summation">
          <FertilizerSummation id={id} />
        </UiKitTabs.Tab>
        <UiKitTabs.Tab label="Active Ingredient Summary">
          <ActiveIngredientSummary id={id} />
        </UiKitTabs.Tab>
      </UiKitTabs>
    </div>
  );
};

PropertyCropZoneProducts.propTypes = {
  id: PropTypes.string.isRequired
};

export default PropertyCropZoneProducts;
